import React, { Suspense, useEffect } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Loader from "react-loaders";
import Layout from "../components/Layout";
import { fetchAdminPermissions } from "../redux/actions/permissions";

const ProtectedRoutes = ({ isLoggedIn }) => {
  const dispatch = useDispatch();
  const perm = useSelector((s) => s.permissions);

  useEffect(() => {
    if (!isLoggedIn) return;
    if (perm.loaded) return;
    if (perm.loading) return;
    dispatch(fetchAdminPermissions()).catch(() => {});
  }, [isLoggedIn, dispatch, perm.loaded, perm.loading]);

  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  if (!perm.loaded && perm.loading) {
    return (
      <Layout>
        <div
          className="loader-container d-flex flex-column align-items-center justify-content-center"
          style={{ minHeight: "60vh" }}
        >
          <Loader type="ball-pulse-rise" />
          <h6 className="mt-4 text-muted">Loading your access…</h6>
        </div>
      </Layout>
    );
  }

  if (!perm.loaded) {
    return (
      <Layout>
        <div className="p-5 text-center text-muted">
          <p>Preparing your workspace…</p>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <Suspense
        fallback={
          <div
            className="loader-container"
            style={{ width: "75vw", height: "75vh" }}
          >
            <div className="loader-container-inner">
              <div className="text-center">
                <Loader type="ball-pulse-rise" />
              </div>
              <h6 className="mt-5">Please wait...</h6>
            </div>
          </div>
        }
      >
        <Outlet />
      </Suspense>
    </Layout>
  );
};

export default ProtectedRoutes;
